module.exports = __webpack_public_path__ + "img/css_icon.7d9ae84d.png";